export const VOICE_CALL_TIMEOUT_MILLISECONDS = 30000;

export const VOICE_TOOL_CALL_TIMEOUT_MILLISECONDS = 30000;

export const VOICE_DATA_CHANNEL_LABEL = 'oai-events';

export const VOICE_MAXIMUM_CAPTIONS = 40;

export const VOICE_ECHO_TAIL_MILLISECONDS = 500;

export const VOICE_CONFIRMATION_PAUSE_MILLISECONDS = 1500;

export const VOICE_DISCONNECTED_GRACE_MILLISECONDS = 8000;

export const VOICE_RETRY_DELAY_MILLISECONDS = 1000;

export const VOICE_IGNORED_SERVER_ERROR_CODES = [
  'response_cancel_not_active',
  'conversation_already_has_active_response',
];

export const VOICE_FAILED_TOOL_OUTPUT = JSON.stringify({ error: 'tool_failed' });

export const VOICE_NO_OPEN_NOTE_OUTPUT = JSON.stringify({ error: 'no_open_session_note_form' });

export const VOICE_NOTE_FOR_OTHER_PATIENT_OUTPUT = JSON.stringify({
  error: 'open_session_note_is_for_another_patient',
});

export const VOICE_NOTE_SAVE_FAILED_OUTPUT = JSON.stringify({ error: 'save_failed' });

export const VOICE_NOTE_SAVED_OUTPUT = JSON.stringify({ status: 'saved_as_draft' });
